import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { take } from 'rxjs/operators';
import { GalaxyConfirmationModalModule } from '@vendasta/galaxy/confirmation-modal';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { SalesOrdersService } from '@vendasta/sales-orders';
import { TranslateModule } from '@ngx-translate/core';

export interface DialogInput {
  orderId: string;
  businessId: string;
  orderDate: string;
  todayDate: string;
}

@Component({
  selector: 'orders-activation-date-confirmation-dialog',
  templateUrl: './activation-date-confirmation-dialog.component.html',
  styleUrls: ['./activation-date-confirmation-dialog.component.scss'],
  imports: [
    GalaxyButtonLoadingIndicatorModule,
    GalaxyConfirmationModalModule,
    MatButtonModule,
    MatDialogClose,
    MatIconModule,
    TranslateModule,
  ],
})
export class ActivationDateConfirmationDialogComponent implements OnInit {
  orderId: string;
  businessId: string;
  orderDate: string;
  todayDate: string;
  updatingDate = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: DialogInput,
    public dialogRef: MatDialogRef<ActivationDateConfirmationDialogComponent>,
    private salesOrdersService: SalesOrdersService,
    private snackbarService: SnackbarService,
  ) {}

  ngOnInit(): void {
    this.orderId = this.data?.orderId;
    this.businessId = this.data?.businessId;
    this.orderDate = this.data?.orderDate;
    this.todayDate = this.data?.todayDate;
  }

  proceedWithPreviousDate(): void {
    this.dialogRef.close(true);
  }

  proceedWithNewDate(): void {
    if (this.updatingDate) return;

    this.updatingDate = true;

    // Set time to 7AM local time
    const currentDate = new Date(new Date().setHours(7, 0, 0, 0));

    this.salesOrdersService
      .updateRequestedActivation(this.orderId, this.businessId, currentDate)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.updatingDate = false;
          this.dialogRef.close(true);
        },
        error: (err) => {
          console.error(err);
          this.snackbarService.openErrorSnack(
            'LIB_ORDERS.SALES_ORDERS.ACTIVATION_DATE_CONFIRMATION_DIALOG.ERROR_REQUESTED_ACTIVATION_UPDATE',
          );
          this.updatingDate = false;
        },
      });
  }
}
